import React from 'react';

import { i18n } from '../../translate/i18n';

import {
  Container,
  Button,
  CssBaseline,
  TextField,
  Grid,
} from '@mui/material';

import { makeStyles } from '@mui/styles';
import {
  NavLinkStyled,
  LogoText,
  Appbar,
} from './styles';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: 'green',
    color: '#fff',
    "&:hover": {
      backgroundColor: 'darkgreen'
    }
  },
}));

export default function SignUp() {
  const classes = useStyles();
  const [value, setValue] = React.useState('type-0');

  function handleChange(event) {
    setValue(event.target.value);
  }

  return <>
    <Appbar />
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <LogoText />
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="fname"
                name="firstName"
                variant="outlined"
                required
                fullWidth
                id="firstName"
                label={i18n.t('textFieldSignUp.name')}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label={i18n.t('textFieldSignUp.email')}
                name="email"
                autoComplete="email"
              />
            </Grid>
            {/* <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Senha"
                type="password"
                id="password"
                autoComplete="current-password"
              />
            </Grid> */}

            <Grid item xs={12}>
              <TextField
                multiline
                variant="outlined"
                required
                fullWidth
                name="motivo"
                label={i18n.t('textFieldSignUp.reason')}
                type="text"
                id="motivo"
                autoComplete=""
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            {i18n.t('btnSignUp.text')}
        </Button>

          <Grid container justifyContent="flex-end">
            <Grid item>
              <NavLinkStyled variant="body2" to='/login'>
                {i18n.t('navLinkStyledSignUp.text')}
              </NavLinkStyled>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  </>;
}